(function () {
  'use strict';

  function initRails(root) {
    root.querySelectorAll('[data-psy-h-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-psy-h-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var n = slides.length;
      if (!n) return;
      var type = rail.getAttribute('data-psy-h-rail');
      var i = 0;
      var caps = [];
      try {
        caps = JSON.parse(rail.getAttribute('data-caps') || '[]');
      } catch (e) {
        caps = [];
      }

      function pageCount() {
        if (type !== 'reviews') return n;
        var visible = window.matchMedia('(max-width: 989px)').matches ? 1 : 3;
        return Math.max(1, n - visible + 1);
      }

      function collapseReviews() {
        if (type !== 'reviews') return;
        rail.querySelectorAll('.psy-h-rv__card.is-open').forEach(function (card) {
          card.classList.remove('is-open');
          var btn = card.querySelector('[data-psy-h-more]');
          if (!btn) return;
          btn.textContent = 'Read more';
          btn.setAttribute('aria-expanded', 'false');
        });
      }

      function set(k) {
        var pages = pageCount();
        i = ((k % pages) + pages) % pages;

        if (type === 'gallery') {
          var pct = 100 / n;
          track.style.width = n * 100 + '%';
          slides.forEach(function (slide) {
            slide.style.width = pct + '%';
          });
          track.style.transform = 'translateX(' + (-i * pct) + '%)';
        } else {
          var card = slides[0];
          var gap = 14;
          var step = card ? card.getBoundingClientRect().width + gap : 0;
          track.style.transform = 'translateX(' + (-i * step) + 'px)';
        }

        rail.querySelectorAll('[data-psy-h-thumb]').forEach(function (t) {
          var idx = parseInt(t.getAttribute('data-psy-h-thumb'), 10);
          var on = idx === i;
          t.classList.toggle('is-on', on);
          if (t.tagName === 'SPAN') {
            t.style.background = on ? '#EDEDE9' : 'rgba(237,237,233,0.35)';
          }
        });

        var capEl = rail.querySelector('[data-psy-h-cap]');
        var counterEl = rail.querySelector('[data-psy-h-counter]');
        if (caps[i]) {
          if (capEl) capEl.textContent = caps[i].toUpperCase();
          if (counterEl) {
            counterEl.textContent =
              String(i + 1).padStart(2, '0') +
              ' / ' +
              String(caps.length).padStart(2, '0') +
              ' · ' +
              caps[i].toUpperCase();
          }
        }

        if (type === 'gallery') revealThumb();
      }

      var thumbs = rail.querySelector('[data-psy-h-thumbs]');
      var prevThumbs = rail.querySelector('[data-psy-h-thumbs-go="prev"]');
      var nextThumbs = rail.querySelector('[data-psy-h-thumbs-go="next"]');

      function thumbStep() {
        if (!thumbs) return 0;
        var thumb = thumbs.querySelector('.psy-h-gal__thumb');
        if (!thumb) return thumbs.clientWidth;
        var gap = parseFloat(window.getComputedStyle(thumbs).columnGap) || 8;
        return thumb.getBoundingClientRect().width + gap;
      }

      function syncThumbBtns() {
        if (!thumbs || !prevThumbs || !nextThumbs) return;
        var max = thumbs.scrollWidth - thumbs.clientWidth;
        var canScroll = max > 2;
        prevThumbs.disabled = !canScroll || thumbs.scrollLeft <= 1;
        nextThumbs.disabled = !canScroll || thumbs.scrollLeft >= max - 1;
      }

      function revealThumb() {
        if (!thumbs) return;
        var active = thumbs.querySelector('.psy-h-gal__thumb.is-on');
        if (!active) return;
        var start = active.offsetLeft;
        var end = start + active.offsetWidth;
        if (start < thumbs.scrollLeft) {
          thumbs.scrollTo({ left: start, behavior: 'smooth' });
        } else if (end > thumbs.scrollLeft + thumbs.clientWidth) {
          thumbs.scrollTo({ left: end - thumbs.clientWidth, behavior: 'smooth' });
        }
        window.requestAnimationFrame(syncThumbBtns);
      }

      if (thumbs && prevThumbs && nextThumbs) {
        thumbs.style.position = 'relative';
        prevThumbs.addEventListener('click', function () {
          thumbs.scrollBy({ left: -thumbStep() * 2, behavior: 'smooth' });
        });
        nextThumbs.addEventListener('click', function () {
          thumbs.scrollBy({ left: thumbStep() * 2, behavior: 'smooth' });
        });
        thumbs.addEventListener('scroll', syncThumbBtns, { passive: true });
        syncThumbBtns();
      }

      rail.querySelectorAll('[data-psy-h-go]').forEach(function (el) {
        el.addEventListener('click', function () {
          collapseReviews();
          var g = el.getAttribute('data-psy-h-go');
          if (g === 'prev') set(i - 1);
          else if (g === 'next') set(i + 1);
          else set(parseInt(g, 10) || 0);
        });
      });

      window.addEventListener('resize', function () {
        set(i);
      });

      set(0);
    });
  }

  function initReviewMore(root) {
    root.querySelectorAll('[data-psy-h-rail="reviews"]').forEach(function (rail) {
      var cards = Array.prototype.slice.call(rail.querySelectorAll('.psy-h-rv__card'));

      function measure(card) {
        var quote = card.querySelector('.psy-h-rv__quote');
        var btn = card.querySelector('[data-psy-h-more]');
        if (!quote || !btn || card.classList.contains('is-open')) return;

        var probe = quote.cloneNode(true);
        probe.removeAttribute('id');
        probe.className = '';
        probe.style.cssText =
          'position:absolute;left:0;top:0;visibility:hidden;display:block;height:auto;max-height:none;-webkit-line-clamp:unset;overflow:visible;width:' +
          quote.clientWidth +
          'px;font:inherit;line-height:inherit;margin:0;';
        quote.parentNode.appendChild(probe);
        var overflows = probe.scrollHeight > quote.clientHeight + 1;
        quote.parentNode.removeChild(probe);
        btn.classList.toggle('is-needed', overflows);
      }

      function collapse(card) {
        card.classList.remove('is-open');
        var btn = card.querySelector('[data-psy-h-more]');
        if (!btn) return;
        btn.textContent = 'Read more';
        btn.setAttribute('aria-expanded', 'false');
      }

      cards.forEach(function (card) {
        var btn = card.querySelector('[data-psy-h-more]');
        if (!btn || btn.getAttribute('data-psy-h-bound')) return;
        btn.setAttribute('data-psy-h-bound', '1');
        btn.addEventListener('click', function () {
          var open = !card.classList.contains('is-open');
          cards.forEach(function (other) {
            if (other !== card) collapse(other);
          });
          card.classList.toggle('is-open', open);
          btn.textContent = open ? 'Read less' : 'Read more';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) measure(card);
        });
        measure(card);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          cards.forEach(measure);
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          cards.forEach(measure);
        }, 150);
      });
    });
  }

  function initWalk(root) {
    root.querySelectorAll('[data-psy-h-walk]').forEach(function (box) {
      var cover = box.querySelector('[data-psy-h-cover]');
      var video = box.querySelector('video');
      if (!cover || !video) return;
      cover.addEventListener('click', function () {
        box.classList.add('is-playing');
        video.play();
      });
    });
  }

  function initSticky() {
    var sticky = document.querySelector('[data-psy-h-sticky]');
    var hero = document.querySelector('[data-psy-h-hero]');
    var footer = document.querySelector('.shopify-section--footer, footer, #shopify-section-footer');
    if (!sticky || !hero) return;

    function update() {
      if (!window.matchMedia('(max-width: 989px)').matches) {
        sticky.classList.remove('is-in');
        return;
      }
      var heroBottom = hero.getBoundingClientRect().bottom;
      var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      var show = heroBottom < 0 && footerTop > window.innerHeight + 40;
      sticky.classList.toggle('is-in', show);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    var root = document.body;
    if (!document.querySelector('.psy-h')) return;
    initRails(root);
    initReviewMore(root);
    initWalk(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
